import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  OnInit,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
  NativeButtonType,
} from '@app/components/button';
import { CheckmarkComponent } from '@app/components/checkmark';
import {
  TextAlign,
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextWeight,
} from '@app/components/text';
import {
  TextInputComponent,
  TextInputDirection,
  TextInputSize,
  TextInputType,
  TextInputWidth,
} from '@app/components/text-input';
import { ToastComponent, ToastPosition } from '@app/components/toast';
import { ViewAlign, ViewComponent, ViewDirection } from '@app/components/view';
import { Spacing } from '@app/shared/types';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-reset-password',
  imports: [
    TranslatePipe,
    TranslateDirective,
    TextInputComponent,
    ButtonComponent,
    CommonModule,
    RouterModule,
    TextComponent,
    ToastComponent,
    ViewComponent,
    CheckmarkComponent,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  password = signal('');
  invalidId = signal(false);
  confirmPassword = signal('');
  passwordCriteria = {
    lengthCheck: computed(
      () =>
        this.password().length >= this.minChar &&
        this.password().length <= this.maxChar
    ),
    uppercase: computed(() => /[A-Z]/.test(this.password())),
    lowercase: computed(() => /[a-z]/.test(this.password())),
    number: computed(() => /[0-9]/.test(this.password())),
    specialChar: computed(() => /[!@#$%^&*(),.?":{}|<>]/.test(this.password())),
    match: computed(
      () =>
        this.password() === this.confirmPassword() &&
        this.password() &&
        this.confirmPassword()
    ),
  };
  isFormValid = computed(() => {
    return Object.values(this.passwordCriteria).every((criteria) => criteria());
  });
  passwordError = false;
  passwordErrorMessage = '';
  private readonly minChar = 8;
  private readonly maxChar = 64;
  InputSize = TextInputSize;
  InputDirection = TextInputDirection;
  InputWidth = TextInputWidth;
  InputType = TextInputType;
  NativeButtonType = NativeButtonType;
  ButtonSize = ButtonSize;
  ButtonType = ButtonType;
  Spacing = Spacing;
  ViewDirection = ViewDirection;
  ViewAlign = ViewAlign;
  TextAlign = TextAlign;
  TextSize = TextSize;
  TextWeight = TextWeight;
  TextHeight = TextHeight;
  TextColor = TextColor;
  ToastPosition = ToastPosition;

  ngOnInit(): void {
    // Now, we should update this once we have the business logic to check the validity of the ID.
    this.route.queryParams.subscribe((params) => {
      if (!params.id) {
        this.invalidId.update(() => true);
      }
    });
  }

  submit(e: Event): void {
    e.preventDefault();
    console.log(
      'we need to implement the code here that is also failing in prev version'
    );
  }
}
